/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PatchApiTracksIdUploadStatusMutationResponse, PatchApiTracksIdUploadStatusPathParams, PatchApiTracksIdUploadStatus400, PatchApiTracksIdUploadStatus401, PatchApiTracksIdUploadStatus403, PatchApiTracksIdUploadStatus404, PatchApiTracksIdUploadStatus500 } from "../../types/PatchApiTracksIdUploadStatus.ts";
import { patchApiTracksIdUploadStatusMutationResponseSchema } from "../../zod/TracksSchemas/patchApiTracksIdUploadStatusSchema.ts";

function getPatchApiTracksIdUploadStatusUrl({ id }: { id: PatchApiTracksIdUploadStatusPathParams["Id"] }) {
  const res = { method: 'PATCH', url: `/api/tracks/${id}/upload-status` as const }  
  return res
}

/**
 * @summary Подтвердить загрузку файла трека
 * {@link /api/tracks/:Id/upload-status}
 */
export async function patchApiTracksIdUploadStatus({ id }: { id: PatchApiTracksIdUploadStatusPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PatchApiTracksIdUploadStatusMutationResponse, ResponseErrorConfig<PatchApiTracksIdUploadStatus400 | PatchApiTracksIdUploadStatus401 | PatchApiTracksIdUploadStatus403 | PatchApiTracksIdUploadStatus404 | PatchApiTracksIdUploadStatus500>, unknown>({ method : "PATCH", url : getPatchApiTracksIdUploadStatusUrl({ id }).url.toString(), ... requestConfig })  
  return patchApiTracksIdUploadStatusMutationResponseSchema.parse(res.data)
}